export default __webpack_public_path__ + "media/images/chevron-29767f0bf173917a0a240f782bde8598.svg";